import React from 'react'
import * as S from '../../styles'

export const SecondRowWidgetsWide = (props) => {
  const notificationsAccessState = props.notificationsAccessState
  const devicesAccessState = props.devicesAccessState
  const devicePolicyAccessState = props.devicePolicyAccessState
  const usersAccessState = props.usersAccessState
  const endPtSecurityAccessState = props.endPtSecurityAccessState

  const renderDeviceStatusWidget = props.renderDeviceStatusWidget
  const renderDevicePolicyStatusWidget = props.renderDevicePolicyStatusWidget
  const renderCustomersUsersStatusWidget =
    props.renderCustomersUsersStatusWidget
  const renderSecureFleetWidget = props.renderSecureFleetWidget
  const renderSolutionsWidget = props.renderSolutionsWidget

  if (
    notificationsAccessState &&
    devicesAccessState &&
    devicePolicyAccessState &&
    usersAccessState
  ) {
    return (
      <S.Grid
        leftChildFrWidth={4}
        middleChildFrWidth={4}
        rightChildFrWidth={4}
      >
        {renderDeviceStatusWidget}
        {renderDevicePolicyStatusWidget}
        {renderCustomersUsersStatusWidget}
      </S.Grid>
    )
  }

  if (
    notificationsAccessState &&
    devicesAccessState &&
    !devicePolicyAccessState &&
    !usersAccessState &&
    endPtSecurityAccessState
  ) {
    return (
      <S.Grid
        leftChildFrWidth={4}
        rightChildFrWidth={8}
      >
        {renderDeviceStatusWidget}
        {renderSecureFleetWidget}
      </S.Grid>
    )
  }

  if (
    notificationsAccessState &&
    devicesAccessState &&
    !devicePolicyAccessState &&
    !usersAccessState &&
    !endPtSecurityAccessState
  ) {
    return (
      <S.Grid
        leftChildFrWidth={4}
        middleChildFrWidth={4}
        rightChildFrWidth={4}
      >
        {renderDeviceStatusWidget}
        {renderSolutionsWidget}
        <S.EmptyDiv />
      </S.Grid>
    )
  }

  if (
    notificationsAccessState &&
    devicesAccessState &&
    !devicePolicyAccessState &&
    usersAccessState &&
    endPtSecurityAccessState
  ) {
    return (
      <S.Grid
        leftChildFrWidth={4}
        middleChildFrWidth={4}
        rightChildFrWidth={4}
      >
        {renderDeviceStatusWidget}
        {renderCustomersUsersStatusWidget}
        <S.EmptyDiv />
      </S.Grid>
    )
  }

  if (
    notificationsAccessState &&
    devicesAccessState &&
    !devicePolicyAccessState &&
    usersAccessState &&
    !endPtSecurityAccessState
  ) {
    return (
      <S.Grid
        leftChildFrWidth={4}
        middleChildFrWidth={4}
        rightChildFrWidth={4}
      >
        {renderDeviceStatusWidget}
        {renderCustomersUsersStatusWidget}
        {renderSolutionsWidget}
      </S.Grid>
    )
  }

  if (
    notificationsAccessState &&
    devicesAccessState &&
    devicePolicyAccessState &&
    !usersAccessState &&
    endPtSecurityAccessState
  ) {
    return (
      <S.Grid
        leftChildFrWidth={4}
        middleChildFrWidth={4}
        rightChildFrWidth={4}
      >
        {renderDeviceStatusWidget}
        {renderDevicePolicyStatusWidget}
        <S.EmptyDiv />
      </S.Grid>
    )
  }

  if (
    notificationsAccessState &&
    devicesAccessState &&
    devicePolicyAccessState &&
    !usersAccessState &&
    !endPtSecurityAccessState
  ) {
    return (
      <S.Grid
        leftChildFrWidth={4}
        middleChildFrWidth={4}
        rightChildFrWidth={4}
      >
        {renderDeviceStatusWidget}
        {renderDevicePolicyStatusWidget}
        {renderSolutionsWidget}
      </S.Grid>
    )
  }

  if (
    (!notificationsAccessState &&
      devicesAccessState &&
      devicePolicyAccessState &&
      usersAccessState &&
      endPtSecurityAccessState) ||
    (notificationsAccessState &&
      !devicesAccessState &&
      devicePolicyAccessState &&
      usersAccessState &&
      endPtSecurityAccessState)
  ) {
    return (
      <S.Grid
        leftChildFrWidth={4}
        rightChildFrWidth={8}
      >
        {renderCustomersUsersStatusWidget}
        {renderSecureFleetWidget}
      </S.Grid>
    )
  }

  if (
    (!notificationsAccessState &&
      devicesAccessState &&
      devicePolicyAccessState &&
      usersAccessState &&
      !endPtSecurityAccessState) ||
    (notificationsAccessState &&
      !devicesAccessState &&
      devicePolicyAccessState &&
      usersAccessState &&
      !endPtSecurityAccessState)
  ) {
    return (
      <S.Grid
        leftChildFrWidth={4}
        middleChildFrWidth={4}
        rightChildFrWidth={4}
      >
        {renderCustomersUsersStatusWidget}
        {renderSolutionsWidget}
        <S.EmptyDiv />
      </S.Grid>
    )
  }

  if (
    (!notificationsAccessState &&
      devicesAccessState &&
      !devicePolicyAccessState &&
      usersAccessState &&
      endPtSecurityAccessState) ||
    (!notificationsAccessState &&
      devicesAccessState &&
      devicePolicyAccessState &&
      !usersAccessState &&
      endPtSecurityAccessState) ||
    (notificationsAccessState &&
      !devicesAccessState &&
      devicePolicyAccessState &&
      !usersAccessState &&
      endPtSecurityAccessState) ||
    (notificationsAccessState &&
      !devicesAccessState &&
      !devicePolicyAccessState &&
      usersAccessState &&
      endPtSecurityAccessState) ||
    (!notificationsAccessState &&
      !devicesAccessState &&
      devicePolicyAccessState &&
      usersAccessState &&
      endPtSecurityAccessState)
  ) {
    return (
      <S.Grid
        leftChildFrWidth={8}
        rightChildFrWidth={4}
      >
        {renderSecureFleetWidget}
        {renderSolutionsWidget}
      </S.Grid>
    )
  }

  if (
    (notificationsAccessState &&
      !devicesAccessState &&
      devicePolicyAccessState &&
      !usersAccessState &&
      !endPtSecurityAccessState) ||
    (notificationsAccessState &&
      !devicesAccessState &&
      !devicePolicyAccessState &&
      usersAccessState &&
      !endPtSecurityAccessState) ||
    (!notificationsAccessState &&
      devicesAccessState &&
      devicePolicyAccessState &&
      !usersAccessState &&
      !endPtSecurityAccessState) ||
    (!notificationsAccessState &&
      devicesAccessState &&
      !devicePolicyAccessState &&
      usersAccessState &&
      !endPtSecurityAccessState) ||
    (!notificationsAccessState &&
      !devicesAccessState &&
      devicePolicyAccessState &&
      !usersAccessState &&
      endPtSecurityAccessState) ||
    (!notificationsAccessState &&
      !devicesAccessState &&
      !devicePolicyAccessState &&
      usersAccessState &&
      endPtSecurityAccessState)
  ) {
    return (
      <S.Grid
        leftChildFrWidth={4}
        middleChildFrWidth={4}
        rightChildFrWidth={4}
      >
        {renderSolutionsWidget}
        <S.EmptyDiv />
        <S.EmptyDiv />
      </S.Grid>
    )
  }

  if (
    (!notificationsAccessState &&
      !devicesAccessState &&
      !devicePolicyAccessState &&
      !usersAccessState) ||
    (notificationsAccessState &&
      !devicesAccessState &&
      !devicePolicyAccessState &&
      !usersAccessState &&
      !endPtSecurityAccessState) ||
    (!notificationsAccessState &&
      devicesAccessState &&
      !devicePolicyAccessState &&
      !usersAccessState &&
      !endPtSecurityAccessState) ||
    (!notificationsAccessState &&
      !devicesAccessState &&
      devicePolicyAccessState &&
      usersAccessState &&
      !endPtSecurityAccessState) ||
    (!notificationsAccessState &&
      !devicesAccessState &&
      devicePolicyAccessState &&
      !usersAccessState &&
      !endPtSecurityAccessState) ||
    (notificationsAccessState &&
      !devicesAccessState &&
      !devicePolicyAccessState &&
      usersAccessState &&
      !endPtSecurityAccessState)
  ) {
    return <></>
  }

  return <></>
}

export default SecondRowWidgetsWide
